import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { CustomInputNumberComponent } from 'src/app/components/custom-components/custom-input-number/custom-input-number.component';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { OrderDetailService } from 'src/app/services/preliminaries/order-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-update-compromise-date',
  templateUrl: './update-compromise-date.component.html',
  styleUrls: ['./update-compromise-date.component.scss'],
  standalone: false
})
export class UpdateCompromiseDateComponent implements OnInit {

  @ViewChild('daysCompromiseDateInput') daysCompromiseDate!: CustomInputNumberComponent;
  suscription: Subscription;
  orderId: number = 0;

  constructor(public orderDetailService: OrderDetailService,
    private toastHandlerService: ToastHandlerService,
    public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.orderId = inputs.orderId;
    });
  }

  close(change: boolean) {
    const data: ModalObjectType = {};
    if (change) {
      data.params = { reload: true };
    }
    this.ref.close(data);
  }

  async updateCompromiseDateByOrderId() {
    try {
      const daysCompromiseDate = this.daysCompromiseDate.value;
      console.warn('valor de los dias', daysCompromiseDate);
      if (daysCompromiseDate && daysCompromiseDate !== 0) {
        await firstValueFrom(this.orderDetailService.updateCompromiseDateByOrderId(this.orderId, daysCompromiseDate));
        this.close(true);
        this.toastHandlerService.showToast('success', 'Se actualizó las fechas de compromiso exitosamente.', '');
      } else {
        this.toastHandlerService.showToast('warning', 'El número de días digitado no es válido.', '');
      }
    } catch (error) {
      console.error('Error al actualizar la fecha de compromiso:', error);
    }
  }
}
